module.exports = __webpack_public_path__ + "static/media/cupones.f453f34e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/cupones.png
// module id = 1197
// module chunks = 0